import { Navigate } from "react-router-dom";
import { useAuth } from "@/hooks/useAuth";
import PendingApproval from "@/pages/PendingApproval";
import AccessDenied from "@/pages/AccessDenied";

export function ProtectedRoute({ children }) {
  const { loading, isAuthenticated, isApproved, isAdmin } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen flex flex-col items-center justify-center bg-[#05050A] gap-3" data-testid="auth-loading-screen">
        <div className="w-6 h-6 border-2 border-[#1A1A22] border-t-[#00E676] rounded-full animate-spin" />
        <div className="text-[#A0A0AB] text-xs uppercase tracking-widest">Loading session…</div>
      </div>
    );
  }
  if (!isAuthenticated) return <Navigate to="/login" replace />;
  if (!isApproved && !isAdmin) return <PendingApproval />;
  return children;
}

export function AdminRoute({ children }) {
  const { loading, isAuthenticated, isAdmin } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen flex flex-col items-center justify-center bg-[#05050A] gap-3">
        <div className="w-6 h-6 border-2 border-[#1A1A22] border-t-[#00E676] rounded-full animate-spin" />
      </div>
    );
  }
  if (!isAuthenticated) return <Navigate to="/login" replace />;
  if (!isAdmin) return <AccessDenied />;
  return children;
}
